import { Renderer2, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
const SCRIPT_PATH = 'https://www.chatbase.co/embed.min.js';

@Injectable({
    providedIn: 'root' 
})

export class ScriptService {
  constructor(@Inject(DOCUMENT) private document: Document) { }
 
  public loadJsScript(renderer: Renderer2, id: string): HTMLScriptElement {
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = SCRIPT_PATH;
    script.id = id;
    renderer.appendChild(this.document.body, script);
    return script;
  }
}